import { forwardRef } from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, className = '', id, ...props }, ref) => {
    const generatedId = id || `checkbox-${Math.random().toString(36).slice(2, 9)}`;
    return (
      <label
        htmlFor={generatedId}
        className={`flex cursor-pointer items-center gap-3 transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      >
        <input
          ref={ref}
          type="checkbox"
          id={generatedId}
          className="peer sr-only"
          {...props}
        />
        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-2 border-neutral-border bg-white transition-colors duration-150 peer-checked:border-brand-primary peer-checked:bg-brand-primary peer-checked:[&>*]:opacity-100 peer-focus-visible:ring-2 peer-focus-visible:ring-brand-primary/20 peer-focus-visible:ring-offset-1 [&>*]:opacity-0">
          <Check className="h-3 w-3 text-white transition-opacity duration-150" aria-hidden />
        </span>
        <span className="text-sm font-medium text-neutral-primary">{label}</span>
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
